import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'
import router from '@/router';

const state = {
    businessUnits: [],
    businessUnit: {},
    businessUnitLogos: [],
    businessUnitBackgrounds: []
};

const getters = {
    getBusinessUnits: (state) => state.businessUnits,
    getBusinessUnitInfo: (state) => state.businessUnit,
    getAvailableBusinessUnitLogos: (state) => state.businessUnitLogos,
    getAvailableBusinessUnitBackgrounds: (state) => state.businessUnitBackgrounds
};

const actions = {
    getClientBusinessUnits( context ) {
        axios.get(`${backendUrl()}/getClientBusinessUnits`, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setBusinessUnits', response.data)
        })
    },

    async getBusinessUnit (context, id) {
        await axios.get(`${backendUrl()}/getBusinessUnit/` + id, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setBusinessUnitInfo', response.data.businessUnit)
            context.commit('setAvailableBusinessUnitLogos', response.data.availableLogos)
            context.commit('setAvailableBusinessUnitBackgrounds', response.data.availableBackgrounds)
        })
    },

    addBusinessUnit(context, data) {
        axios.post(`${backendUrl()}/addBusinessUnit`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token')}
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },

    deleteBusinessUnit(context, id) {
        axios.post(`${backendUrl()}/deleteBusinessUnit`, 
        {
            id: id
        }, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token')}
        }).then(response => {
            context.dispatch('handleResponse', response)
            context.dispatch('getClientBusinessUnits')
        })
    },

    updateBusinessUnit(context, data) {
        axios.post(`${backendUrl()}/updateBusinessUnit`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response)
            if(localStorage.getItem('clientConfig') && response.data.status == 'success') {
                let clientConfig = JSON.parse(localStorage.getItem('clientConfig'))
                if(clientConfig.businessUnitId == response.data.updatedUnit) {
                    context.dispatch('updateBusinessUnitsImages', {
                        loginLogo: response.data.newLoginLogoUrl,
                        loginBackground: response.data.newLoginBackgroundUrl,
                        navbarLogo: response.data.newNavbarLogoUrl,
                        navbarBackground: response.data.newNavbarBackgroundUrl
                    })
                }
            }
        })
    },

    async switchToBusinessUnit(context, id) {
        await axios.post(`${backendUrl()}/switchToBusinessUnit`, 
        {
            id: id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            if(response.data.status == 'success') {
                // create client config localstorage needed for business units
                let clientConfig = {}
                clientConfig.businessUnitId = response.data.businessUnitId
                clientConfig.businessUnitShortName = response.data.businessUnitShortName
                localStorage.setItem('clientConfig', JSON.stringify(clientConfig))

                // dispatch action to update logos and backgrounds for business unit
                context.dispatch('updateBusinessUnitsImages', {
                    loginLogo: response.data.newLoginLogoUrl,
                    loginBackground: response.data.newLoginBackgroundUrl,
                    navbarLogo: response.data.newNavbarLogoUrl,
                    navbarBackground: response.data.newNavbarBackgroundUrl
                })
            }
        })
    },

    // NS-11260 Function to switch back from business unit to default client, PW
    async resetBusinessUnit(context) {
        if(localStorage.getItem('clientConfig')) {

            localStorage.removeItem('clientConfig')

            await axios.post(`${backendUrl()}/resetBusinessUnit`, null, {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            }).then(response => {
                if(response.data.status == 'success') {
                    //NS-11260 Update images back to default ones, PW
                    context.dispatch('updateBusinessUnitsImages', {
                        loginLogo: response.data.newLoginLogoUrl,
                        loginBackground: response.data.newLoginBackgroundUrl,
                        navbarLogo: response.data.newNavbarLogoUrl,
                        navbarBackground: response.data.newNavbarBackgroundUrl
                    })
                }
            })   
        }
    },

    setBusinessUnitFromUrl(context, unitShortName) {
        axios.get(`${backendUrl()}/setBusinessUnitFromUrl/` + unitShortName
        ).then(response => {
            if(response.data.status == 'success') {
                // create client config localstorage needed for business units
                // if we get business unit as parameter which is not client short name then set states and localstorage
                // if passed business unit is the same as client short name then delete client config localstorage and only update states
                if(response.data.action == 'setBusinessUnit') {
                    let clientConfig = {}
                    clientConfig.businessUnitId = response.data.businessUnitId
                    clientConfig.businessUnitShortName = response.data.businessUnitShortName
                    localStorage.setItem('clientConfig', JSON.stringify(clientConfig))

                    // dispatch action to update logos and backgrounds for business unit
                    context.dispatch('updateBusinessUnitsImages', {
                        loginLogo: response.data.newLoginLogoUrl,
                        loginBackground: response.data.newLoginBackgroundUrl,
                        navbarLogo: response.data.newNavbarLogoUrl,
                        navbarBackground: response.data.newNavbarBackgroundUrl
                    })
                } else {
                    localStorage.removeItem('clientConfig')
                    context.dispatch('updateBusinessUnitsImages', {
                        loginLogo: response.data.newLoginLogoUrl,
                        loginBackground: response.data.newLoginBackgroundUrl,
                        navbarLogo: response.data.newNavbarLogoUrl,
                        navbarBackground: response.data.newNavbarBackgroundUrl
                    })
                }
            }

            router.push({ name: 'portal'})
        })
    },

    updateBusinessUnitsImages(context, data) {
        // update urls stored in local storage
        let templateDetails = JSON.parse(localStorage.getItem('templateDetails'))
        templateDetails.loginLogoImage = data.loginLogo
        templateDetails.loginBackgroundImage = data.loginBackground
        templateDetails.navbarLogoImage = data.navbarLogo
        templateDetails.navbarBackgroundImage = data.navbarBackground
        localStorage.setItem('templateDetails', JSON.stringify(templateDetails))

        // update state with new logo urls
        context.commit('setNavbarLogoImage', data.navbarLogo)
        context.commit('setNavbarBackgroundImage', data.navbarBackground)
        context.commit('setLoginLogoImage', data.loginLogo)
        context.commit('setLoginBackgroundImage', data.loginBackground)
    },

    async getAvailableBusinessUnitLogos(context) {
        await axios.post(`${backendUrl()}/getAvailableBusinessUnitLogos`, '',
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token')}
        }).then(response => {
            context.commit('setAvailableBusinessUnitLogos', response.data)
        })
    },

    async getAvailableBusinessUnitBackgrounds(context) {
        await axios.post(`${backendUrl()}/getAvailableBusinessUnitBackgrounds`, '',
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token')}
        }).then(response => {
            context.commit('setAvailableBusinessUnitBackgrounds', response.data)
        })
    },

    uploadBusinessUnitImage(context, data) {
        axios.post(`${backendUrl()}/uploadBusinessUnitImage`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': "bearer " +  vuecookie.get('token')
                }
            }).then(response => {
                context.dispatch('handleResponse', response)
                if(response.data.status == 'success') {
                    switch(response.data.type) {
                        case 'businessUnitLogos':
                            context.dispatch('getAvailableBusinessUnitLogos')
                            break
                        case 'businessUnitBackgrounds':
                            context.dispatch('getAvailableBusinessUnitBackgrounds')
                            break
                        case 'businessUnitLoginLogos':
                            context.dispatch('getAvailableBusinessUnitLoginLogos')
                            break
                        case 'businessUnitLoginBackgrounds':
                            context.dispatch('getAvailableBusinessUnitLoginBackgrounds')
                            break
                    }
                } 
            })
    },

    deleteBusinessUnitImage(context, data) {
        axios.post(`${backendUrl()}/deleteBusinessUnitImage`, data,
            {
                headers: {'Authorization': "bearer " +  vuecookie.get('token')}
            }).then(response => {
                context.dispatch('handleResponse', response)
                if(response.data.status == 'success') {
                    switch(response.data.type) {
                        case 'businessUnitLogos':
                            context.dispatch('getAvailableBusinessUnitLogos')
                            break
                        case 'businessUnitBackgrounds':
                            context.dispatch('getAvailableBusinessUnitBackgrounds')
                            break
                        case 'businessUnitLoginLogos':
                            context.dispatch('getAvailableBusinessUnitLoginLogos')
                            break
                        case 'businessUnitLoginBackgrounds':
                            context.dispatch('getAvailableBusinessUnitLoginBackgrounds')
                            break
                    }
                } 
            })
    }
};

const mutations = {
  setBusinessUnits: (state, units) => (state.businessUnits = units),
  setBusinessUnitInfo: (state, unitInfo) => (state.businessUnit = unitInfo),
  setAvailableBusinessUnitLogos: (state, logos) => (state.businessUnitLogos = logos),
  setAvailableBusinessUnitBackgrounds: (state, backgrounds) => (state.businessUnitBackgrounds = backgrounds)
};

export default {
    state,
    getters,
    actions,
    mutations
}
